__webpack_require__.p = "https://bmidxbcroatiaplpreprod.netlify.app/";